<template>
  <footer class="footer">
    <div class="_footer-inner">
      <h5>個人情報保護方針</h5>
      <div class="_footer-navi-list">
        <div class="_footer-navi-item _footer-navi-item-1">
          <a
            href="https://ji-red.co.jp/privacy/"
            target="_blank"
            >JR東日本伊藤忠不動産開発</a
          >
        </div>
        <div
          class="_footer-navi-item _footer-navi-item-2"
          v-if="currentUser.status == 'contractor'"
        >
          <a href="https://www.ji-h.co.jp/privacy" target="_blank"
            >JR東日本伊藤忠ハウジング</a
          >
        </div>
        <div class="_footer-navi-item _footer-navi-item-3">
          <a href="https://www.itc-uc.co.jp/privacy/" target="_blank"
            >伊藤忠アーバンコミュニティ</a
          >
        </div>
      </div>
      <!-- / _footer-navi-list -->
      <div class="_footer-navi-list">
        <div class="_footer-navi-item">
          <a href="/i-salon/docs/kiyaku.html" target="_blank">ご利用規約</a>
        </div>
        <div class="_footer-navi-item">
          <router-link
            :to="{
              name: 'in-contact',
              params: { mc_code: mcCode },
            }"
            >お問い合わせ</router-link
          >
        </div>
        <div class="_footer-navi-item">
          <router-link
            :to="{
              name: 'mypage',
              params: { mc_code: mcCode },
            }"
          >
            ユーザー情報
          </router-link>
        </div>
      </div>
      <!-- / _footer-navi-list -->
      <h2 class="_footer-logo">
        <img
          src="/i-salon/assets/img/common/logo-itochu_property_development.png"
          alt="JR東日本伊藤忠不動産開発"
          class="_footer-logo-1"
        />
        <img
          v-if="currentUser.status == 'contractor'"
          src="/i-salon/assets/img/common/logo-itochu_housing.png"
          alt="JR東日本伊藤忠ハウジング"
          class="_footer-logo-2"
        />
        <img
          src="/i-salon/assets/img/common/logo-itochu_urban_community.png"
          alt="伊藤忠アーバンコミュニティ"
          class="_footer-logo-3"
        />
      </h2>
      <p class="_footer-copyrights">
        &copy; 2026 JREAST &amp; ITOCHU REAL ESTATE DEVELOPMENT,
        <span v-if="currentUser.status == 'contractor'">
          JREAST &amp; ITOCHU HOUSING,
        </span>
        ITOCHU Urban Community
      </p>
      <!-- / _footer-copyrights -->
    </div>
    <!-- / _footer-inner -->
  </footer>
</template>

<script>
export default {};
</script>

<style></style>
